var reactIs_production_min = {};
export {
  reactIs_production_min as __exports
};
